// ErrorWithCode
// 通常のErrorに加え、エラーコードを含めるためのカスタムエラー。
// 以下のように用いる。
//   try {
//     do something
//   } catch (e) {
//     if (e instanceof ErrorWithCode) {
//       switch (e.code) {
//         case 500:
//           handling
//           break;
//         case 50000:
//           handling
//           break;
//         default:
//           default handling
//           break;
//       }
//     }
//     handle other Error
//   }
export class ErrorWithCode extends Error {
  constructor(public code: number, e?: string) {
    super(e);
    this.name = new.target.name;
  }
}
